import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout-thank-you" }
const _hoisted_2 = { class: "checkout-thank-you__upper" }
const _hoisted_3 = { class: "checkout-thank-you__header" }
const _hoisted_4 = { class: "checkout-thank-you__message" }
const _hoisted_5 = { class: "checkout-thank-you__text" }
const _hoisted_6 = { class: "checkout-thank-you__booking-no" }
const _hoisted_7 = { class: "checkout-thank-you__text-content" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "checkout-thank-you__summary" }
const _hoisted_11 = { class: "checkout-thank-you__section checkout-thank-you__hotel-infos-section" }
const _hoisted_12 = { class: "checkout-thank-you__hotel-infos" }
const _hoisted_13 = { class: "checkout-thank-you__hotel-infos-left-column" }
const _hoisted_14 = {
  key: 0,
  class: "checkout-thank-you__section checkout-thank-you__checkout-travel-details-section"
}
const _hoisted_15 = { class: "checkout-thank-you__checkout-travel-details" }
const _hoisted_16 = {
  key: 1,
  class: "checkout-thank-you__printer-section"
}
const _hoisted_17 = {
  class: "checkout-thank-you__icon-group",
  onclick: "window.print(); return false;"
}

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import type { ClientType } from '@/interfaces/common';
import type { ShoppingCart } from '@/interfaces/checkout/shopping-cart';
import FeatureList from '@lmt-rpb/FeatureList/FeatureList.vue';
import type { FormattedTravelerPrice, LabeledPrice, Price } from '@/interfaces/checkout/offer-data';
import { useStore } from '@/components/common/store';
import { computed } from 'vue';
import { formatPrice } from '@/js/utils/priceUtils';
import CheckoutInfos from '@lmt-rpb/CheckoutInfos/CheckoutInfos.vue';
import CheckoutInfoFlightDetails from '@lmt-rpb/CheckoutInfoFlightDetails/CheckoutInfoFlightDetails.vue';
import PriceSummary from '@lmt-rpb/PriceSummary/PriceSummary.vue';

interface Props {
	shoppingCart: ShoppingCart;
	client?: ClientType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutThankYou',
  props: {
    shoppingCart: {},
    client: { default: 'at' }
  },
  setup(__props: any) {

const store = useStore();

const props = __props;
const hotel = props.shoppingCart?.Travel?.Hotel;

const status = computed((): string => props.shoppingCart.Status);

const isPackage = computed((): boolean => props.shoppingCart?.Travel.TravelType === 'Package');

const finalPriceLabelConverted = computed((): string => {
	let pricelabelConverted = '';
	if (props.shoppingCart.Pricing?.Total.Converted?.Currency && props.shoppingCart.Pricing.Total.Converted?.Amount) {
		pricelabelConverted = formatPrice(
			props.shoppingCart.Pricing.Total.Converted.Amount + insurancePrice.value + getStornoPrice(),
			props.shoppingCart.Pricing?.Total.Converted.Currency,
			true
		);
	}
	return pricelabelConverted;
});
const travelPriceLabel = computed((): string => getFormattedPrice(props.shoppingCart.Pricing.Total));

const insurance = computed(() => {
	const insurances = props.shoppingCart.Pricing?.Insurance;
	if (!insurances || !insurances.length) {
		return undefined;
	}
	return {
		insuranceName: insurances[0].Label,
		priceInformation: getFormattedPrice(insurances[0].Price),
	};
});

const titleWording = computed((): string =>
	props.client === 'ch' ? 'Wir wünschen Ihnen schöne Ferien!' : 'Wir wünschen Ihnen einen fantastischen Urlaub!'
);

const insurancePrice = computed((): number => {
	if (!props.shoppingCart.Pricing || !props.shoppingCart.Pricing.Insurance || !props.shoppingCart.Pricing.Insurance.length) {
		return 0;
	}

	return props.shoppingCart.Pricing.Insurance[0].Price.Amount || 0;
});

function getFormattedPrice(price: Price, isConverted = true): string {
	if (isConverted && price.Converted?.Currency && price.Converted?.Amount) {
		return formatPrice(price.Converted.Amount, price.Converted.Currency, true);
	}
	return formatPrice(price.Amount, price.Currency, true);
}

function getStornoPrice(): number {
	if (
		!props.shoppingCart.Pricing ||
		!props.shoppingCart.Pricing.OptionalFlexRate ||
		!props.shoppingCart.Pricing.OptionalFlexRate.Amount
	) {
		return 0;
	}

	let stornoPriceValue =
		props.shoppingCart.Pricing.OptionalFlexRate.Converted?.Amount || props.shoppingCart.Pricing.OptionalFlexRate.Amount;

	if (props.client !== 'ch') {
		stornoPriceValue = props.shoppingCart.Pricing.OptionalFlexRate.Amount;
	}
	return stornoPriceValue;
}

const storno = computed(() => props.shoppingCart.Pricing?.OptionalFlexRate);

const stornoPriceLabel = computed((): string => {
	const currency =
		props.shoppingCart.Pricing?.OptionalFlexRate?.Converted?.Currency || props.shoppingCart.Pricing?.OptionalFlexRate?.Currency;
	if (props.shoppingCart.Pricing?.OptionalFlexRate?.Currency && getStornoPrice()) {
		return formatPrice(getStornoPrice(), currency, true);
	}
	return '';
});

// TODO: Add logic for unverified price for checkUnable offers.
// Check when thank you page is implemented
const finalPriceLabel = computed((): string => {
	let priceLabel = '';
	if (props.shoppingCart.Pricing?.Total.Currency && props.shoppingCart.Pricing.Total.Amount) {
		priceLabel = formatPrice(
			props.shoppingCart.Pricing.Total.Amount + insurancePrice.value + getStornoPrice(),
			props.shoppingCart.Pricing?.Total.Currency,
			true
		);
	}
	return priceLabel;
});

const travelerPrices = computed((): FormattedTravelerPrice[] => {
	if (!props.shoppingCart.Pricing.Travel) {
		return [];
	}

	if (status.value === 'CheckUnable' || status.value === 'Undefined') {
		return [
			{
				Label: 'Alle Personen',
				Price: getFormattedPrice(props.shoppingCart.Pricing.Total),
			},
		];
	}

	return props.shoppingCart.Pricing.Travel?.map((traveler: LabeledPrice) => ({
		Label: traveler.Label,
		Price: getFormattedPrice(traveler.Price),
	}));
});

const phoneNumber = computed((): string => store.state.config.phone);

const phoneLink = computed((): string => `tel:${store.state.config.phoneLink}`);

const printPage = computed((): boolean => typeof window.print === 'function');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(titleWording.value), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, " Buchungsreferenznummer: " + _toDisplayString(_ctx.shoppingCart.ShoppingCartID), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _cache[0] || (_cache[0] = _createTextVNode(" In den nächsten 15 Minuten erhalten Sie eine E-Mail zur Bestätigung Ihres verbindlichen Buchungsauftrags bzw. Ihrer Buchung an ")),
            _createElementVNode("a", {
              href: `mailto:${_ctx.shoppingCart.Customer.Email}`
            }, _toDisplayString(_ctx.shoppingCart.Customer.Email), 9 /* TEXT, PROPS */, _hoisted_8)
          ]),
          _createElementVNode("p", null, [
            _cache[1] || (_cache[1] = _createTextVNode(" Sollten Sie diese E-Mail nicht erhalten, kontaktieren Sie bitte umgehend unser ")),
            _cache[2] || (_cache[2] = _createElementVNode("b", null, "Service Center", -1 /* HOISTED */)),
            _cache[3] || (_cache[3] = _createTextVNode(" unter ")),
            _createElementVNode("a", {
              href: `${phoneLink.value}`
            }, _toDisplayString(phoneNumber.value), 9 /* TEXT, PROPS */, _hoisted_9),
            _cache[4] || (_cache[4] = _createTextVNode(" Mo-Fr 8-22 Uhr, Sa 9-22 Uhr, So & Feiertage 11-22 Uhr. "))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(CheckoutInfos, {
        "iff-code": _unref(hotel)?.IffCode,
        "hotel-address": _unref(hotel)?.Address,
        "hotel-category": _unref(hotel)?.Category,
        "hotel-name": _unref(hotel)?.Name,
        "tour-operator": _ctx.shoppingCart.Travel.TourOperator,
        client: _ctx.client
      }, null, 8 /* PROPS */, ["iff-code", "hotel-address", "hotel-category", "hotel-name", "tour-operator", "client"]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(FeatureList, {
              "is-long-date": !isPackage.value,
              "is-checkout-thank-you": true,
              offer: _ctx.shoppingCart,
              location: 'thankyouPage',
              "is-first-feature-bold": true
            }, null, 8 /* PROPS */, ["is-long-date", "offer"])
          ])
        ])
      ]),
      (_ctx.shoppingCart.Travel.Flight)
        ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (isPackage.value)
                ? (_openBlock(), _createBlock(CheckoutInfoFlightDetails, {
                    key: 0,
                    outbound: _ctx.shoppingCart.Travel.Flight.OutboundFlightSegments,
                    inbound: _ctx.shoppingCart.Travel.Flight.InboundFlightSegments
                  }, null, 8 /* PROPS */, ["outbound", "inbound"]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(PriceSummary, {
        class: "checkout-thank-you__price-detail-section",
        storno: storno.value,
        "actual-traveller-prices": travelerPrices.value,
        "is-chf": _ctx.client === 'ch',
        "final-price-with-currency": finalPriceLabel.value,
        "total-formatted": finalPriceLabelConverted.value ? finalPriceLabelConverted.value : finalPriceLabel.value,
        "flex-price": stornoPriceLabel.value,
        "travel-price-with-discount-formatted": travelPriceLabel.value,
        "travel-price-formatted": finalPriceLabelConverted.value ? finalPriceLabelConverted.value : finalPriceLabel.value,
        "insurance-price": insurance.value?.priceInformation ?? '',
        insurance: insurance.value,
        "is-package": isPackage.value,
        "with-overview-header": true
      }, null, 8 /* PROPS */, ["storno", "actual-traveller-prices", "is-chf", "final-price-with-currency", "total-formatted", "flex-price", "travel-price-with-discount-formatted", "travel-price-formatted", "insurance-price", "insurance", "is-package"]),
      (printPage.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(BaseIcon, {
                class: "checkout-thank-you__print-icon",
                name: "printer"
              }),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Drucken", -1 /* HOISTED */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})